/** Pocket Meme's Discord: a permanent invite (never expires, no use limit) that lands in #rules. site/template.html links it too. */
export const DISCORD_INVITE = "https://discord.gg/QJv2GPWnEw";

/** Opens an outside page in a new tab without leaving the game. False when there is no window or the browser blocked it. */
export function openLink(url: string): boolean {
  if (typeof window === "undefined" || typeof window.open !== "function") return false;
  const tab = window.open(url, "_blank");
  if (!tab) return false;
  tab.opener = null;
  return true;
}
